/**
 * @author huancheng.zhan<zhanhuancheng@ukelink.com>
 * @date 2018/4/9
 * @description
 */
let get = function(url){
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.onload = function(){
            if(xhr.status == 200){
                resolve(JSON.parse(xhr.responseText));
            }
            else {
                reject(null);
            }
        };
        xhr.onerror = function(){
            reject(null);
        }
        xhr.send(null);
    });

};
export default {
    getConfig() {
        let hash = Math.random();
        return get(`/config/app-config.json?hash=${hash}`);
        // return get(`/wifi/config/app-config.json?hash=${hash}`);
    }
}



// WEBPACK FOOTER //
// ./src/data/app-config.js